<template>
	<section id="catalog" class="section-spacing">
		<div id="compare-modal">
			<button type="button" class="close" @click="closeCompare()">
				<span class="fas fa-times"></span>
			</button>
			<div class="modal">
				<div class="artwork artwork-1">
					<div class="img"></div>
					<div class="title"></div>
				</div>
				<div class="artwork artwork-2">
					<div class="img"></div>
					<div class="title"></div>
				</div>
			</div>
		</div>
		<div class="loader" v-show="isLoading">
			<div class="loader-icon">
				<span class="fas fa-circle-notch fa-spin"></span>
			</div>
		</div>
		<div class="inner">
			<div class="col-row auto-col-clear">
				<div class="col l3 m12 s12">
					<button id="toggleFilters">Filters</button>
					<div id="selectedFilterTags" class="clearfix">
						<button @click="selectMeta('sq', '')" v-if="model.sq">Search for: {{model.sq}}</button>
						<button @click="selectMeta('attributed_to', false)" v-if="model.attributed_to">Attributed to: Yes</button>
						<button @click="selectMeta('dimension', '')" v-if="model.dimension">Dimension: {{list.dimensions[model.dimension]}}</button>
						<button @click="selectMeta('favourites', false)" v-if="model.favourites">Favourites: Yes</button>
						<button @click="selectMeta('foundry_mark', '')" v-if="model.foundry_mark">Foundry mark: {{model.foundry_mark}}</button>
						<button @click="selectMeta('item_in', '')" v-if="model.item_in">Item in: {{model.item_in}}</button>
						<button @click="selectMeta('materials', '')" v-if="model.materials.length">Materials: {{model.materials.join(', ')}}</button>
						<button @click="selectMeta('medium', '')" v-if="model.medium">Medium: {{model.medium}}</button>
						<button @click="selectMeta('apply_year', false)" v-if="model.apply_year">Year: {{model.date.from + ' - ' + model.date.to}}</button>
					</div>
					<div id="filters">
						<div class="meta-box" v-if="compare.length">
							<h4 class="meta-title">Compare</h4>
							<div class="toggle">
								<div class="artwork-compare" v-for="idx in maxCompare" v-html="compare[idx - 1] ? getArtworkById(compare[idx - 1]).title.main : 'Select artwork to compare'"></div>
							</div>
						</div>
						<h4>Refine results</h4>
						<div class="meta-box">
							<h4 class="meta-title">Materials</h4>
							<div class="toggle">
								<div class="ui-checkbox" v-for="material, key in list.materials">
									<label>
										<input type="checkbox" v-model="model.materials" :value="material" @change="reset()" />
										<span class="checkbox"></span>
										<span v-text="material"></span>
									</label>
								</div>
							</div>
						</div>
						<div class="form-block">
							<label id="sort-by" class="form-label">
								<span class="label">Sort by</span>
								<div class="form-field select">
									<select class="field" v-model="model.sortby" @change="sortBy()" :disabled="isLoading">
										<option value="">Default</option>
										<option value="A-Z">A-Z</option>
										<option value="Z-A">Z-A</option>
										<option value="YearAsc">Year ↑</option>
										<option value="YearDesc">Year ↓</option>
									</select>
								</div>
							</label>
						</div>
						<div class="meta-box seperator">
							<div class="ui-checkbox">
								<label>
									<input type="checkbox" v-model="model.favourites" @change="reset()" />
									<span class="checkbox"></span>
									<span>My favourites</span>
								</label>
							</div>
						</div>
						<div class="meta-box seperator">
							<div class="ui-checkbox">
								<label>
									<input type="checkbox" v-model="model.attributed_to" @change="reset()" />
									<span class="checkbox"></span>
									<span>Attributed to</span>
								</label>
							</div>
						</div>
						<div class="meta-box seperator">
							<div class="ui-radio">
								<label>
									<input type="radio" v-model="model.item_in" @change="reset()" value="Museum" />
									<span class="radio"></span>
									<span>Museum</span>
								</label>
							</div>
							<div class="ui-radio">
								<label>
									<input type="radio" v-model="model.item_in" @change="reset()" value="Auction" />
									<span class="radio"></span>
									<span>Auction</span>
								</label>
							</div>
							<div class="ui-radio">
								<label>
									<input type="radio" v-model="model.item_in" @change="reset()" value="Public Monument" />
									<span class="radio"></span>
									<span>Public Monument</span>
								</label>
							</div>
							<div class="ui-radio">
								<label>
									<input type="radio" v-model="model.item_in" @change="reset()" value="Private Collections" />
									<span class="radio"></span>
									<span>Private Collections</span>
								</label>
							</div>
						</div>
						<div class="meta-box is-accordion">
							<h4 class="meta-title">Locations</h4>
							<div class="toggle">
								<div class="ui-checkbox" v-for="location, index in list.locations">
									<label>
										<input type="checkbox" v-model="model.tags['locations']" :value="location" @change="reset()" />
										<span class="checkbox"></span>
										<span v-text="location"></span>
									</label>
								</div>
							</div>
						</div>
						<div id="date-range" class="meta-box is-accordion">
							<h4 class="meta-title">Year</h4>
							<div class="toggle">
								<div class="ui-checkbox">
									<label>
										<input type="checkbox" v-model="model.apply_year" @change="reset()" />
										<span class="checkbox"></span>
										<span>Search by year</span>
									</label>
								</div>
								<div id="slider-range"></div>
								<div class="input-range">
									<input type="number" class="date-from" v-model="model.date.from">
									<span>to</span>
									<input type="number" class="date-to" v-model="model.date.to">
								</div>
							</div>
						</div>
						<div class="meta-box is-accordion">
							<h4 class="meta-title">Medium</h4>
							<div class="toggle">
								<div class="meta" v-for="med, key in list.medium" :class="{'active': med === model.medium}" @click="selectMeta('medium', med)">
									<span class="name" v-text="med"></span>
								</div>
							</div>
						</div>
						<div class="meta-box is-accordion">
							<h4 class="meta-title">Dimensions</h4>
							<div class="toggle">
								<div class="meta" v-for="dimension, key in list.dimensions" :class="{'active': key === model.dimension}" @click="selectMeta('dimension', key)">
									<span class="name" v-text="dimension"></span>
								</div>
							</div>
						</div>
						<div class="meta-box is-accordion">
							<h4 class="meta-title">Foundry Marks</h4>
							<div class="toggle">
								<div class="meta" v-for="foundry_mark, key in list.foundry_marks" :class="{'active': foundry_mark === model.foundry_mark}" @click="selectMeta('foundry_mark', foundry_mark)">
									<span class="name" v-text="foundry_mark"></span>
								</div>
							</div>
						</div>
						<div class="meta-box is-accordion">
							<h4 class="meta-title">Busts</h4>
							<div class="toggle">
								<div class="ui-checkbox" v-for="bust, label in list.busts">
									<label>
										<input type="checkbox" v-model="model.tags['busts']" @change="reset()" :value="label" />
										<span class="checkbox"></span>
										<span v-text="label"></span>
									</label>
								</div>
							</div>
						</div>
						<div class="meta-box is-accordion">
							<h4 class="meta-title">Animals</h4>
							<div class="toggle">
								<div class="ui-checkbox" v-for="animal, index in list.animals">
									<label>
										<input type="checkbox" v-model="model.tags['animals']" :value="animal" @change="reset()" />
										<span class="checkbox"></span>
										<span v-text="animal"></span>
									</label>
								</div>
							</div>
						</div>
						<div class="meta-box is-accordion">
							<h4 class="meta-title">Full-length Portraits</h4>
							<div class="toggle">
								<div class="option">
									<span class="name">Men</span>
									<div class="ui-checkbox" v-for="portrait, label in list.fullLengthPortraits_Men">
										<label>
											<input type="checkbox" v-model="model.tags['fullLengthPortraits_Men']" @change="reset()" :value="label" />
											<span class="checkbox"></span>
											<span v-text="label"></span>
										</label>
									</div>
								</div>
								<div class="option">
									<span class="name">Women</span>
									<div class="ui-checkbox" v-for="portrait, label in list.fullLengthPortraits_Women">
										<label>
											<input type="checkbox" v-model="model.tags['fullLengthPortraits_Women']" @change="reset()" :value="label" />
											<span class="checkbox"></span>
											<span v-text="label"></span>
										</label>
									</div>
								</div>
								<div class="option">
									<span class="name">Children</span>
									<div class="ui-checkbox" v-for="portrait, label in list.fullLengthPortraits_Children">
										<label>
											<input type="checkbox" v-model="model.tags['fullLengthPortraits_Children']" @change="reset()" :value="label" />
											<span class="checkbox"></span>
											<span v-text="label"></span>
										</label>
									</div>
								</div>
								<div class="option">
									<span class="name">Groups</span>
									<div class="ui-checkbox" v-for="portrait, label in list.fullLengthPortraits_Groups">
										<label>
											<input type="checkbox" v-model="model.tags['fullLengthPortraits_Groups']" @change="reset()" :value="label" />
											<span class="checkbox"></span>
											<span v-text="label"></span>
										</label>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="col l9 m12 s12">
					<div id="list-artworks" class="col-row col-auto-clear">
						<div class="col l3 m3 s6" v-for="post, index in posts" :key="`post-${index}`" v-if="hasPosts">
							<div class="artwork">
								<figure class="img respond">
									<a :href="post.guid">
										<img :src="post.image" :alt="post.title.main">
									</a>
								</figure>
								<h5 class="title">
									<a :href="post.guid" v-html="post.title.main + (post.title.secondary ? ' (' + post.title.secondary + ')' : '')"></a>
								</h5>
								<div class="meta">
									<span v-if="post.year" v-html="post.year + ' &vert; '"></span>
									<span v-text="post.medium"></span>
								</div>
								<div class="actions">
									<favourite-artwork v-if="user_id" :post_id="post.id" :favourited="post.favourited"></favourite-artwork>
									<button type="button" v-if="post.image" class="compare fas fa-retweet" @click="addToCompare(post.id)" :disabled="post.compared"></button>
								</div>
							</div>
						</div>
					</div>
					<div class="noArtworks" v-if="!hasPosts && !isLoading">
						No artworks found
					</div>
				</div>
			</div>
		</div>
		<div class="view-more ui-text-center" v-if="showLoadMore">
			<button type="button" class="ui-btn ui-btn-outline" @click="loadMore" :disabled="isFinished || isLoading" v-text="isLoading ? 'Loading...' : 'Load more'">Load more</button>
		</div>
		<a href="javascript:void(0);" id="backToTop" class="fa fa-chevron-up"></a>
	</section>
</template>
<script>
	import {slider} from 'jquery-ui';
	import {postsApi, userApi} from '../../api';
	import helper from '../../helpers';
	import moment from 'moment';
	import {debounce, find} from 'lodash';
	export default {
		props: {
			datefrom: {
				type: String,
				required: true
			},
			dateto: {
				type: String,
				required: true
			}
		},
		data() {
			return {
				user_id: 0,
				page: 1,
				per_page: 60,
				total_pages: 0,
				posts: [],
				isLoading: false,
				isFinished: false,
				maxCompare: 2,
				compare: [],
				model: {
					sq: '',
					apply_year: false,
					date: {
						from: 0,
						to: 0
					},
					sortby: "",
					attributed_to: false,
					item_in: "",
					medium: "",
					materials: [],
					dimension: "",
					foundry_mark: "",
					tags: {
						busts: [],
						animals: [],
						locations: [],
						fullLengthPortraits_Men: [],
						fullLengthPortraits_Women: [],
						fullLengthPortraits_Children: [],
						fullLengthPortraits_Groups: []
					},
					favourites: false,
				},
				list: {
					locations: [
						"Italy",
						"France ",
						"Spain ",
						"Germany",
						"Switzerland",
						"Belgium",
						"Sweden",
						"Ireland",
						"UK",
						"USA",
						"Russia",
						"Canada ",
						"Argentina",
					],
					medium: [
						"Drawings",
						"Prints",
						"Paintings",
						"Sculptures",
						"Reliefs",
					],
					materials: [
						"Bronze",
						"Clay",
						"Marble",
						"Plaster",
						"Wax",
					],
					dimensions: {
						"small": "Small (0-40cm)",
						"medium": "Medium (41-100cm)",
						"large": "Large (Over 100cm)",
					},
					foundry_marks: [
						"Hébrard",
						"Robecchi",
						"Roman Bronze Works",
						"Valsuani",
						"Other",
					],
					busts: {
						"Male": ["Malebust"],
						"Female": ["femalebust"],
						"Children": ["Bustchild"],
					},
					animals: [
						"Cat",
						"Cow",
						"Dog",
						"Elephant",
						"Horse",
					],
					fullLengthPortraits_Men: {
						"Rembrandt Bugatti": ["Bugatti"],
						"Enrico Caruso": ["Caruso"],
						"Robert de Montesqiou": ["Montesqiou"],
						"Henry de Rothschild": ["Rothschild"],
						"Giuseppe Garibaldi": ["Garibaldi"],
						"George Bernard Shaw": ["Shaw"],
						"Leo Tolstoy": ["Tolstoy"],
						"William K. Vanderbilt": ["Vanderbilt"],
						"Athlete": ["Athlete"],
						"Cowboy": ["Cowboy"],
						"Male Nudes": ["Malenude"],
						"Leo Tolstoy on horseback": ["Tolstoyhorseback"],
						"Self-portrait": ["Troubetzkoy"],
						"Unidentified men riding horses": ["manridinghorse"],
						"Unidentified men": ["Man"],
						"Other": ["othermen"],
					},
					fullLengthPortraits_Women: {
						"After the Ball": ["ball"],
						"Lady Constance Stewart Richardson": ["Richardson"],
						"Marchesa Luisa Casati": ["Casati"],
						"Mrs Harry Payne Whitney": ["Mrswhitney"],
						"Angelina Troubetzkoy": ["Angelina"],
						"Elin Troubetzkoy": ["Elin"],
						"Ada Troubetzkoy Winans": ["Ada"],
						"Dancers": ["ballerina"],
						"Princess Gagarine with her daughter Marina": ["Princessgagarine"],
						"Oldest Daughter of William K. Vanderbilt": ["olddaughterVanderbilt"],
						"Youngest Daughter of William K. Vanderbilt": ["daughterVanderbilt"],
						"Unidentified Women": ["Woman"],
						"Other": ["otherwoman"],
					},
					fullLengthPortraits_Children: {
						"Children": ["Fullchild"],
					},
					fullLengthPortraits_Groups: {
						"Family": ["Family"],
						"Other": ["groupother"],
					}
				}
			}
		},
		methods: {
			closeCompare() {
				let self = this;
				self.compare.forEach((val, idx) => {
					self.getArtworkById(val).compared = false;
				});
				self.compare = [];
				$('#compare-modal').hide();
			},
			addToCompare(id) {
				let self = this;
				if(self.compare.length !== self.maxCompare) {
					let artwork = self.getArtworkById(id);
					self.compare.push(id);
					artwork.compared = true;
					self.$forceUpdate();
					if(self.compare.length === self.maxCompare) {
						var compareModal = $('#compare-modal'),
							artwork1 = self.getArtworkById(self.compare[0]),
							artwork2 = self.getArtworkById(self.compare[1]);
						compareModal.find('.artwork-1').find('.img').css('background-image', 'url("' + encodeURI(artwork1.image) + '")');
						compareModal.find('.artwork-1').find('.title').text(artwork1.title.main);
						compareModal.find('.artwork-2').find('.img').css('background-image', 'url("' + encodeURI(artwork2.image) + '")');
						compareModal.find('.artwork-2').find('.title').text(artwork2.title.main);
						compareModal.show();
					}
				}
			},
			getTagValues() {
				let self = this, obj = self.model.tags, tags = [];
				Object.entries(obj).forEach(([tagkey, selectedvals]) => {
					if(selectedvals.length) {
						Object.entries(selectedvals).forEach(([vkey, vvalue]) => {
							if(
								tagkey === 'fullLengthPortraits_Men' ||
								tagkey === 'fullLengthPortraits_Women' ||
								tagkey === 'fullLengthPortraits_Children' ||
								tagkey === 'fullLengthPortraits_Groups' ||
								tagkey === 'busts'
							) {
								let searchterms = self.list[tagkey][vvalue];
								searchterms.forEach((sval, skey) => {
									tags.push(sval);
								});
							} else {
								tags.push(vvalue);
							}
						});
					}
				});
				return tags;
			},
			addToTags(values) {
				let self = this;
				values.forEach((val, key) => {
					if(self.model.tags.includes(val)) {
						var valueIndex = self.model.tags.indexOf(val);
						if(valueIndex > -1) {
							self.model.tags.splice(valueIndex, 1);
						}
					} else {
						self.model.tags.push(val);
					}
				});
				self.reset();	
			},
			updateItemIn(value) {
				let self = this;
				self.model.item_in = value;
				self.reset();
			},
			sortBy() {
				let self = this;
				self.page -= 1;
				self.isFinished = false;
				self.posts = [];
				self.getArtworks();
			},
			inRange(x, min, max) {
				return ((x-min)*(x-max) <= 0);
			},
			getArtworkById(id) {
				let self = this, post = _.find(self.posts, ['id', id]);
				return post;
			},
			getArtworks() {
				let self = this,
					$slider = $("#slider-range"),
					args = {
						page: self.page,
						per_page: self.per_page,
						image_size: 'large',
						order: self.model.sortby,
						attributed_to: self.model.attributed_to,
						item_in: self.model.item_in,
						medium: self.model.medium,
						materials: self.model.materials.join(','),
						foundry_mark: self.model.foundry_mark,
						dimension: self.model.dimension,
						tags: self.getTagValues().join(','),
						favourites: self.model.favourites,
						sq: self.model.sq
					}
				if(self.model.apply_year) {
					args['year_from'] = self.model.date.from;
					args['year_to'] = self.model.date.to;
				}
				// set history push state
				self.setHistoryPushState(args);
				self.isLoading = true;
				postsApi.getArtworks(args).then(response => {
					let data = response.data;
					self.user_id = data.user_id;
					self.isLoading = false;
					self.total_pages = data.total_pages;
					$('.filter').attr('disabled', self.isLoading);
					if(data.total_posts === 0) {
						self.isFinished = true;
					} else {
						self.posts.push.apply(self.posts, data.posts);
						if(self.page === data.total_pages) {
							self.isFinished = true;
						}
						/*// only push user to top if there are posts and the page is 1
						if(self.hasPosts && self.page === 1) {
							window.scroll(0, 0);
						}*/
						self.page += 1;
					}
				}, error => {
					console.log(error);
				});
			},
			selectMeta(key, value) {
				let self = this;
				if(self.model[key] === value) {
					self.model[key] = '';
				} else {
					self.model[key] = value;
				}
				if(key === 'sq') {
					// clear search input
					$('#search').removeClass('search-active').find('input').val('');
				}
				if(key === 'materials') {
					self.model.materials = [];
				}
				self.reset();
			},
			formatDate(date) {
				return moment(date).format("MMMM D, YYYY");
			},
			loadMore() {
				let self = this;
				self.getArtworks();
			},
			setHistoryPushState(args) {
				let self = this;
				// set param as follows
				var urlparams = {
					sq: args.sq,
					attributed_to: args.attributed_to ? 'yes' : '',
					item_in: args.item_in,
					medium: args.medium,
					materials: args.materials,
					foundry_mark: args.foundry_mark,
					dimension: args.dimension,
					tags: btoa(JSON.stringify(self.model.tags)),
					favourites: args.favourites ? 'yes' : '',
					year_from: args.year_from,
					year_to: args.year_to,
				};
				// if url has params, set new history url for fetched user query
				var paramurl = window.location.href.split(/[?#]/)[0];
				urlparams = Object.entries(urlparams).reduce((a,[k,v]) => (v ? (a[k]=v, a) : a), {});
				if(Object.keys(urlparams).length) {
					paramurl = paramurl + '?' + $.param(urlparams);
				}
				history.pushState('', '', decodeURIComponent(paramurl));
			},
			initMounted() {
				let self = this;
				self.isLoading = true;

				// set model from get param url
				self.model.sq = helper.$_GET('sq');
				self.model.attributed_to = helper.$_GET('attributed_to') === 'yes' ? true : false;
				self.model.item_in = helper.$_GET('item_in');
				self.model.medium = helper.$_GET('medium');
				self.model.materials = helper.$_GET('materials') ? helper.$_GET('materials').split(',') : ["Bronze"];
				self.model.foundry_mark = helper.$_GET('foundry_mark');
				self.model.dimension = helper.$_GET('dimension');
				if(helper.$_GET('tags')) {
					self.model.tags = JSON.parse(atob(helper.$_GET('tags')));
				} 
				self.model.favourites = helper.$_GET('favourites') === 'yes' ? true : false;

				if(helper.$_GET('year_from') && helper.$_GET('year_to')) {
					self.model.date.year_from = helper.$_GET('year_from');
					self.model.date.year_to = helper.$_GET('year_to');
					self.model.apply_year = true;
				}

				// fetch artworks on load
				setTimeout(() => {
					self.getArtworks();
				}, 500);
				// listen to on favourite artwork
				self.$root.$on('on-favourite', function(data) {
					let post = _.find(self.posts, ['id', data.post_id]);
					post.favourited = data.favourited;
				});
				$('.is-accordion .meta-title').on('click', function() {
					$(this).toggleClass('active').next().slideToggle();
				});
				// set dates
				var datefrom = parseInt(helper.$_GET('year_from') || self.datefrom),
					dateto = parseInt(helper.$_GET('year_to') || self.dateto);

				self.model.date.from = datefrom;
				self.model.date.to = dateto;
				var $slider = $("#slider-range").slider({
					orientation: "horizontal",
					range: true,
					min: datefrom,
					max: dateto,
					values: [datefrom, dateto],
					slide: function(event, ui) {
						self.model.date.from = ui.values[0];
						self.model.date.to = ui.values[1];
					},
					stop: function(event, ui) {
						if(self.model.apply_year) {
							self.reset();
						}
					}
				});
				function updateSlider(datefrom, dateto) {
					if(self.inRange(self.model.date.from, datefrom, dateto) && self.inRange(self.model.date.to, datefrom, dateto)) {
						$('.date-from').attr('min', datefrom).attr('max', self.model.date.to);
						$('.date-to').attr('min', self.model.date.from).attr('max', dateto);
						$slider.slider("values", [self.model.date.from, self.model.date.to]);
					}
				}
				setTimeout(() => {
					updateSlider(datefrom, dateto);
				}, 1000);
				// watch changes to input date fields
				$(".date-from, .date-to").map(function(){
					$(this).on("input", function() {
						updateSlider(datefrom, dateto);
					});
					$(this).on("input change", _.debounce(() => {
						if(self.model.apply_year) {
							self.reset();
						}
					}, 1000));
				});
				// scroll back to top
				$('#backToTop').on('click', function() {
					$('html, body').animate({
						scrollTop: 0
					}, 500);
				});
			},
			reset() {
				let self = this;
				self.page = 1;
				self.total_pages = 0;
				self.posts = [];
				self.isFinished = false;
				self.getArtworks();
			}
		},
		computed: {
			isSearch() {
				let self = this;
				return helper.$_GET('sq') ? true : false;
			},
			hasPosts() {
				let self = this;
				return self.posts.length ? true : false;
			},
			showLoadMore() {
				let self = this;
				return self.total_pages >= 2 ? true : false
			}
		},
		mounted() {
			let self = this;
			self.initMounted();
		}
	}
</script>